export async function createUpdateModal () {
    return new Promise ((resolve, reject) => {
        let modal = document.createElement('calcite-modal'); 
        modal.id = "updateModal";
        modal.style = "z-index: 10000;";
        modal.beforeClose = () => {


        }

        const navEnd = document.getElementById("navEnd");

        let button = document.createElement('calcite-button');
        button.id = "releaseNotesButton"; 
        button.iconStart = "file-text"; 
        button.label = "Release Notes"; 
        button.innerText = "Release Notes"

        navEnd.append(button); 


        button.addEventListener("click", function () {
            modal.open = true;
        });




        (async () => {
            await customElements.whenDefined("calcite-modal");
            await modal.componentOnReady();
            modal.shadowRoot.querySelector(".modal").style.width = "100%";
            // const updatebutton = document.getElementById("releaseNotesButton");
            // const updatemodal = document.getElementById("ReleaseNotesModal");
            // updatemodal.shadowRoot.querySelector(".modal").style.width = "100%";
            // updatebutton?.addEventListener("click", function () {
            //     modal.open = true;
            // });
            let headerDiv = document.createElement('div');
            headerDiv.slot = "header"; 
            headerDiv.innerHTML = "Release Notes"; 
            modal.appendChild(headerDiv);
    

            modal.shadowRoot.querySelector(".header").style = "background-color: #274861";
            modal.shadowRoot.querySelector(".modal").style = "width: 95%; border-radius: 0;";

     
             })();




        let contentDiv = document.createElement('div'); 
        contentDiv.id = "updateContent";
        contentDiv.slot = "content"; 
        
        contentDiv.innerHTML = `
<div class="row">
    <div class="col-12">
        <h2>About</h2>
        <p>This section is meant to catalog the various updates the WinGIS team makes to our maps. Check back here often if you're interested in any changes we're making.</p>
         <h2>
            WinGISMaps 2.3.5 - Fix + Flood Zones Change - 11/7/2024
        </h2>
        <ul>
            <li>
                <h3 class="fs-4">Fix</h3>
                <ul>
                    <li>Fixed an issue that caused the Markup tab to break when pressing the delete key to delete a shape.</li>
                </ul>
            </li>
            <li>
                <h3 class="fs-4">Flood Zones Change</h3>
                <ul>
                    <li>Unfortunately, FEMA has been experiencing intermittent server issues for an extended period of time. To avoid this disrupting our users any further, we have downloaded FEMA's data, and we are now hosting it for our maps ourselves. The data available is now more limited, but it should be accessible much more consistently.</li>
                </ul>
            </li>
        </ul>
        <h2>
            WinGISMaps 2.3.4 - Small Markup Fixes - 10/28/2024
        </h2>
        <ul>
        <li>
            <h3 class="fs-4">Fixes</h3>
            <ul>
                <li>Users can now press enter to finish drawing a shape.</li>
                <li>Fixed a bug that caused the markup tab to break if the user tried to highlight an area without a feature. </li>
                <li>Set the default line measurement unit to imperial.</li>
            </ul>
        </li> 
        </ul> 
        <h2>
            WinGISMaps 2.3.3 - Internal Release Hotfixes - 10/11/2024
        </h2>
        <ul>
        <li>
            <h3 class="fs-4">Fixes</h3>
            <ul>
                <li>Fixed a bug that caused buffers to sometimes display in the wrong spatial reference. </li>
                <li>Fixed a bug that caused markup to sometimes display in the wrong spatial reference. </li>
                            
            </ul>
        </li> 
        </ul>
        <h2>
            WinGISMaps 2.3.2 - Fixes - 10/9/2024
        </h2>
        <ul>
        <li>
            <h3 class="fs-4">General Fixes</h3>
            <ul>
                <li>2.3.1 accidentally included an update to the Esri JS api that broke our maps for users who cannot run WebGL2. This has been reverted.</li>
                <li> Made the buffer and markup tools more accurate.</li> 
                            
            </ul>
        </li> 
        </ul>
        <h2>
            WinGISMaps 2.3.1 - Fixes - 10/9/2024
        </h2>
        <ul>
        <li>
            <h3 class="fs-4">Summary Fixes</h3>
            <ul>
                <li>Fixed a bug that caused summaries to display incorrectly when printing.</li>
                <li>Fixed a bug that caused summaries to display without their basemaps.</li>
                            
            </ul>
        </li> 
        </ul>
        <h2>
            WinGISMaps 2.3.0 - Improvements & Fixes - 9/20/2024
        </h2>
        <ul>
        <li>
            <h3 class="fs-4">Accessibility & Responsiveness updates</h3>
            <ul>
                <li>Added a tabbable "skip to map" option for keyboard-only users.</li>
                <li>Users can now identify the center of the map by pressing 'enter' while the map is within focus. (blue outline)</li>
                <li>Combed over the maps and made several user interface improvements targeted at mobile users.</li>
                <li>Made some small adjustments to spacing across the maps user interfaces for polish.</li>   
                            
            </ul>
        </li> 
        <li>
            <h3>Map Loading Changes</h3>
            <ul>
                <li>Maps now obscure themselves until they are done with their initial load. This helps prevent any bugs that might occur when a user tries to use the map before it is ready.</li>
                <li>Maps now show the progress of their initial load. This is intended to create a more responsive experience for users on slower internet connections.</li>
                <li>Removed Bootstrap from the WinGIS maps.</li>
            </ul>
        </li>
        <li>
             <h3>Fixes</h3>
             <ul>
                <li>Fixed an issue that caused parcel summaries to break on the Sales Locator's property search.</li>
                <li>Fixed an issue that caused the buffer tool to break in some instances.</li>
             </ul>
        </li>
        </ul>
        <h2>
            WinGISMaps 2.2.0 - Changes & Fixes - 9/13/2024
        </h2>
        <ul>
        <li>
            <h3 class="fs-4">Summary Fixes & Additions</h3>
            <ul>
                <li><b>Parcel summaries now have a button to copy a sharable link to the clipboard.</b> As the standalone parcel summary pages have been retired, we've implemented the ability to link to a parcel summary from a map.</li>
                <li>Summary maps now display with our 2024 aerials.</li>
                <li>Boone parcel summaries now more clearly display unnassigned addresses.</li>
                <li>Parcel summaries involving 'area' attributes, like zoning and school districts, are now more accurate.</li>
                <li>Fixed a bug that caused summary maps to sometimes display without a basemap.</li>
                <li>Wards now display more accurately on Boone layers.</li>
                <li>Parcel summary images now display more reliably. </li>
                <li>Fixed a bug that caused Pecatonica zoning info to load incorrectly in summaries.</li>
                <li>Summaries no longer redundantly show the same flood zone info more than once.</li>
                <li>Changed the way Senior Assessment Freezes display in summaries to try and make them less confusing. Rather than showing a blank dollar amount, they now display "Yes", similar to how the assessor site does.</li>
            </ul>
        </li>
        </ul>
        <h2>
            WinGIS Public 2.1.0 - Changes - 8/27/2024
        </h2>
        <ul>
        <li>
            <h3 class="fs-4">Small Summary Rework</h3>
            <ul>
                <li>To better illustrate the loading process of summaries, the scrim overlay has been replaced with individual loading symbols for each section.</li>
                <li>Fixed a bug that caused summary display buttons to appear incorrectly in property searches.</li>
            </ul>
        </li>
        </ul>
        <h2>
            WinGIS Public 2.0.4 - Hotfix - 8/26/2024
        </h2>
        <ul>
             <li>A number of WinGIS users are still on old hardware that does not have the capabilities to run ESRI JS Api 4.29+. We are rolling back to 4.28 for now, and will consider our upgrade options in the future.</li>
             <li>Fixed a bug that caused layers to load in the wrong order.</li>
             <li>Fixed a bug that allowed users to zoom in far enough to break some map functionality.</li>
        </ul>
        <h2>
            WinGIS Public 2.0.3 - Major Release - 8/23/2024
        </h2>
        <hr />
        <ul>
            <li>
                <h3 class="fs-4">UI Facelift</h3>
                <ul>
                    <li>The new WinGIS user interface has received a few adjustments.</li>
                    <li>The UI now incorporates more of Esri's Calcite Design System.</li>
                    <li>We have adjusted the colors of the sidebar and widgets.</li>
                    <li>Widgets now have a descriptive title at the top of their window, to assist new users.</li>
                    <li>The UI now has a settings widget. For now, the only setting is to toggle light/dark mode. More settings may come in the future based on user input.</li>
                    <li>Fixed several CSS bugs impacting the display of the sidebar.</li>
                    <li><b>Instead of highlighting every identified feature, maps now highlight the feature correspondent to the attributes currently displayed in the sidebar.</b> Navigating through the different features updates the highlight.</li>
                    <li>Features with a 'point' geometry (manholes, hydrants, etc), are now highlighted properly when identified.</li>
                </ul>
            </li>
            <li class="mt-3">
                <h3 class="fs-4">Additions to the Markup tab</h3>
                We have <b>completely rebuilt the Markup tab.</b> It no longer uses esri's sketch UI. It now uses a new, but familiar UI made to mimic esri's. This should provide a simpler framework for adding more tools in the future.
                <ul>
                    <li>
                        <b>The "highlight" tool: </b> This can be used to add a graphic with the exact shape of a feature (for example, a parcel). This tool is designed to be useful for those trying to print maps highlighting different parcels/features.
                    </li>
                    <li>
                        <b>The markup styles section: </b> This section allows users to adjust the colors and line styles of their markup. More options may be added to this section over time.
                    </li>
                    <li>
                        <b>The resize tool: </b> When selecting a shape with a length or area, users can now view their length/area in feet/square feet. From there, users can adjust shape size by length/area. (These values are rounded to the nearest whole number, and thus not necessarily exact.)
                    </li>
                    <li>
                        Context adjustments: The markup tab now shows/hides more controls based on what the user is actually doing. As well, tooltips are always enabled now.
                    </li>
                </ul>

            </li>
            <li class="mt-3">
                <h3 class="fs-4">Summary Reworks</h3>
                Users can now <b>view and print parcel summaries without leaving the map</b>. The summaries have also received a slight touch up for readability.
                <ul>
                    <li>
                        The map summary view has a new print feature. This allows users to print a summary quickly and easily, in a standardized document format.
                    </li>
                    <li>Summaries now automatically generate a static image of the parcel; This allows summaries to function correctly on browsers (like firefox) that don't support printing a dynamic map.</li>
                    <li>Summaries now provide an error message if an error occurs retrieving summary data. </li>
                </ul>
            </li>
            <li class="mt-3">
                <h3 class="fs-4">Misc</h3>

                <ul>

                    <li>
                        Added an assessor page for Shirland.
                    </li>
                    <li>
                        Fixed a bug that caused the buffer tool to create a polygon instead of a polyline with the polyline tool.
                    </li>

                    <li>
                        Optimized the loading of most maps.
                    </li>
                    <li>
                        The area measuring tool now allows you to measure multiple areas, as well as print with a measured area on the map.
                    </li>
                    <li>
                        PIN labels are now available on public maps as a layer.
                    </li>
                    <li>
                        Fixed several bugs regarding the reference ties form.
                    </li>
                    <li>
                        Made the data request map more responsive to user input.
                    </li>
                    <li>Features on maps now highlight with an empty, orange outline when selected, to better contrast against different basemaps.</li>
                    <li>Fixed a bug that caused the map navigation to cover the sidebar.</li>

                    <li>
                        The Geocomps map now highlights parcels with more contrasting colors. It now also auto-zooms to the highlighted parcels. Users can now add pin-labels to the
                        highlighted parcels as well. This change has been made to the Geolist map as well. The Geolist map now also accepts pins with dashes.
                    </li>
                    <li>
                        Fixed a bug that sent users back to the root page when clicking the WinGIS logo from a subscription map.
                    </li>
                    <li>
                        Fixed a bug that impacted the usability of the Sales Locator map.
                    </li>
                    <li>
                        Identify results are now sorted in reverse order, to prioritize parcel views.
                    </li>
                    <li>Updates to the maps should no longer require users to clear their cache.</li>
                    <li>
                        We have implemented the new FEMA service on relevant maps. This service is still experiencing some technical difficulties at the time of writing, but it works intermittently. FEMA's server issues are out of our control; We may investigate other options for our users in the future.
                    </li>
                </ul>
            </li>

        </ul>
    </div>

</div>
        `;
        
        
        modal.appendChild(contentDiv);


        document.body.appendChild(modal);

        resolve(); 

    })

}